import Accommodation from './accommodation';

export default Accommodation;
